module.exports = __webpack_public_path__ + "static/media/akb.f55a4054.png";